exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-5b72f721]{position:relative;padding:20px;height:100%}.logo[data-v-5b72f721]{display:block;margin:30px auto}.at-char[data-v-5b72f721]{color:#4e7eef}.create-notebook[data-v-5b72f721]{display:block;margin:30px auto;padding:.5rem 1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b72f721","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 172
// module chunks = 0